import styled, { css } from "styled-components";
import { Select } from "antd";

export const FilterTabWrapper = styled.div`
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  gap: 12px;
  justify-content: space-between;
  overflow-x: auto;
  padding: 0.5rem 1rem;
  background-color: white;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  border-radius: 0.375rem;
`;

export const CountBadge = styled.span<{ $textColor?: string }>`
  font-size: 12px;
  font-weight: 700;
  margin-left: 6px;
  display: inline-flex;
  align-items: center;
  color: ${({ $textColor }) => $textColor || "#1f2937"};
  transition: color 0.2s ease;
`;

export const FilterButton = styled.button<{ active?: boolean; $borderColor?: string; $backgroundColor?: string; $textColor?: string; $hoverBackground?: string }>`
  display: flex;
  align-items: center;
  gap: 0.25rem; /* gap-1 */
  padding: 0.375rem 0.75rem; /* py-1.5 px-3 */
  border-radius: 9999px; /* fully rounded - rounded-full */
  border: 1.5px solid;
  transition: all 0.2s ease-in-out;
  font-size: 0.875rem;
  font-weight: 500;
  cursor: pointer;

  ${(props) =>
    props.active
      ? css`
          background-color: ${props.$textColor || "#2563eb"};
          color: ${props.$backgroundColor || "#ffffff"};
          border-color: ${props.$borderColor || props.$textColor || "#2563eb"};
          box-shadow: 0 6px 20px rgba(0, 0, 0, 0.15);
          transform: translateY(-1px) scale(1.02);
          &:hover {
            background-color: ${props.$textColor || "#2563eb"};
            color: ${props.$backgroundColor || "#ffffff"};
          }
        `
      : css`
          background-color: ${props.$backgroundColor || "#ffffff"};
          color: ${props.$textColor || "#1f2937"};
          border-color: ${props.$borderColor || "#d1d5db"};

          &:hover {
            background-color: ${props.$textColor || "#dbeafe"};
            color: ${props.$backgroundColor || "#ffffff"};
            box-shadow: 0 4px 14px rgba(0, 0, 0, 0.12);
            transform: translateY(-1px);
          }
        `}
  &:hover .status-count-badge {
    color: #ffffff;
  }
`;

export const FilterButtonImage = styled.img<{ active?: boolean }>`
  width: 18px;
  height: 18px;
  border-radius: 50%;
  object-fit: cover;
  ${(props) =>
    props.active
      ? `filter: brightness(0) invert(1);`
      : `filter: none;`}
`;

export const StatusFilters = styled.div`
  display: flex;
  flex-wrap: nowrap;
  gap: 10px;
  align-items: center;
  flex-shrink: 0;
`;

export const StatusLabel = styled.span`
  font-size: 12px;
  letter-spacing: 0.02em;
  text-transform: uppercase;
  color: #6b7280;
  font-weight: 600;
`;

export const EstablishmentSelectWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 180px;
`;

export const EstablishmentSelect = styled(Select)`
  min-width: 180px;
`;
